import {useQuery} from "@tanstack/react-query";
import {getListTeachers} from "api/teacher.api.ts";
import {useLocation} from "react-router-dom";
import styled from "styled-components";
import {List} from "./sections/List";
import Map from "./sections/Map";
import {useState} from "react";
import {mediaSizes, pageContainerStyles} from "../../../ui/theme";

export const MapPage = () => {
    const {state} = useLocation();

    const [mapCenter, setMapCenter] = useState(state.coordinates);

    const {data} = useQuery({
        queryKey: ["getListTeachers", state.typeOfClass.label, mapCenter],
        queryFn: () =>
            getListTeachers({
                query: state.typeOfClass.label,
                ...mapCenter,
            }),
        enabled: !!state,
    });

    return (
        <Container>
            <List typeOfClass={state.typeOfClass.label} classes={data?.data || []}/>
            <Map
                typeOfClass={state.typeOfClass.label}
                location={state.coordinates}
                classes={data?.data || []}
                setMapCenter={setMapCenter}
            />
        </Container>
    );
};

const Container = styled.div`
    ${pageContainerStyles}
    font-family: var(--font-secondary);
    display: grid;
    grid-template-columns: 1fr;
    gap: 2rem;
    height: auto;
    @media (width >= ${mediaSizes.lg}) {
        grid-template-columns: 1fr 0.9fr;
        height: 85dvh;
        overflow: hidden;
    }
`;
